import axiosInstance from "api/axiosInstance";
export const transaction = async (accessToken) => {
    try {
      const response = await axiosInstance.get("/business/@me/transactions", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status == 403) {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
        throw {
          statusCode: status,
          message:
            error.response.data?.message || "خطای ناشناخته   ",
        };
      } else {
        throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
      }
    }
  };


export const getOnesubscription = async ({accessToken,id}) => {
  try {
    const response = await axiosInstance.get('/business/@me/subscriptions/search', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        id
      }
    });
    return response.data;
  } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status == 403) {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
        throw {
          statusCode: status,
          message:
            error.response.data?.message || "خطای ناشناخته   ",
        };
      } else {
        throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
      }
    }
};
